module.exports = __webpack_public_path__ + "static/img/monitiornew1.28bb4d1d.svg";